import React from "react";

const sizes = {
  texts: "text-[18px] font-medium",
  textmd: "text-[20px] font-medium",
  headingxs: "text-[14px] font-semibold",
  headings: "text-[16px] font-semibold",
  headingmd: "text-[18px] font-semibold",
  headingmd2: "text-[51px] font-semibold md:text-[38px] sm:text-[32px]",
  headinglg: "text-[56px] font-semibold md:text-[48px] sm:text-[42px]",
  headinglg2: "text-[61px] font-semibold md:text-[26px] sm:text-[26pxs]",
  headingxl: "text-[72px] font-semibold md:text-[48px]",
};

export type HeadingProps = Partial<{
  className: string;
  as: any;
  size: keyof typeof sizes;
}> &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

const Heading: React.FC<React.PropsWithChildren<HeadingProps>> = ({
  children,
  className = "",
  size = "texts",
  as,
  ...restProps
}) => {
  const Component = as || "h6";

  return (
    <Component
      className={`text-black-900 font-manrope ${className} ${sizes[size] as keyof typeof sizes}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Heading };
